const getOEEMetrics = (state) => {
  return state?.oee;
};

export { getOEEMetrics };
